import axJava from "./axJava";

// 恒信通H5人脸识别
export function GetHXTLivenessDetectionUrl(data = {}) {
  return axJava({
    url: "/api/FaceVerify/GetHXTLivenessDetectionUrl",
    method: "post",
    data
  });
}

// 恒信通H5人脸识别结果查询
export function QueryHXTLivenessDetectionResult(data = {}) {
  return axJava({
    url: "api/FaceVerify/QueryHXTLivenessDetectionResult",
    method: "post",
    data
  });
}

// 阿里H5人脸识别
export function InitALiFaceVerify(data = {}) {
  return axJava({
    url: "/api/FaceVerify/InitALiFaceVerify",
    method: "post",
    data
  });
}

// 阿里H5人脸识别结果查询
export function GetALiFaceVerifyResult(data = {}) {
  return axJava({
    url: "api/FaceVerify/GetALiFaceVerifyResult",
    method: "post",
    data
  });
}